import { prefetchAppSettings } from "./settingsApi";
import { setCachedAppSettings, getCachedAppSettings } from "./settingsCache";
import { fetchWidgetsFromDb, isWidgetsCacheReady, setCachedWidgets } from "./widgetApi";

let bootstrapPromise = null;
let bootstrapComplete = false;

/**
 * Once per tab session (after install is ready): settings + widgets list.
 * Safe to call multiple times — returns the same promise.
 */
export function bootstrapAppSession() {
  if (bootstrapPromise) {
    return bootstrapPromise;
  }

  bootstrapPromise = Promise.all([prefetchAppSettings(), fetchWidgetsFromDb()])
    .then(() => {
      if (!getCachedAppSettings()) {
        setCachedAppSettings({ customCss: "", customJs: "" });
      }
    })
    .catch((e) => {
      console.warn("[bootstrapAppSession]", e);
      if (!getCachedAppSettings()) {
        setCachedAppSettings({ customCss: "", customJs: "" });
      }
      if (!isWidgetsCacheReady()) {
        setCachedWidgets([]);
      }
    })
    .finally(() => {
      bootstrapComplete = true;
    });

  return bootstrapPromise;
}

/** True only after bootstrap finished (success or failure). */
export function isAppSessionBootstrapped() {
  return bootstrapComplete;
}

export function waitForAppBootstrap() {
  return bootstrapAppSession();
}

/** After save/delete widget or settings — optional full refresh. */
export function resetAppBootstrap() {
  bootstrapPromise = null;
  bootstrapComplete = false;
}
